<template>
  <div class="my-context-menu-box" tabindex="0" outline="0" hidefocus="true" :style="formStyle" v-if="formVisible">
    <div class="my-context-menu-block">
      <ul>
        <li
          :index="index + ''"
          v-for="(item, index) in showOptions"
          :key="index + ''"
          :class="item.disabled || disabled ? 'my-context-menu-item-disabled' : 'my-context-menu-item'"
          @click.stop="handleSure(item)"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 是否显示
      formVisible: false,
      showOptions: [],
      options: [],
      mouseX: 0,
      mouseY: 0,
      value: {},
      disabled: false,
      // 样式
      formStyle: { width: 'auto' }
    }
  },
  methods: {
    showWindows() {
      this.value = {}
      this.showOptions = []
    },
    setposition() {
      const clientWidth = window.innerWidth
      const clientHeight = window.innerHeight
      let top = this.mouseY
      let left = this.mouseX
      if (top > clientHeight / 2 && clientHeight - top < this.options.length * 32) {
        if (this.options.length * 32 > clientHeight / 2) {
          top = top - clientHeight / 2
        } else {
          top = top - this.options.length * 32
        }
      }

      let width = 150
      let ele = document.getElementsByClassName('my-context-menu-block')
      if (ele.length > 0) {
        if (ele[0].offsetWidth > width) {
          width = ele[0].offsetWidth
        }
      }
      if (left + width > clientWidth) {
        left = left - width
      }
      this.showOptions = [...this.options]
      this.formStyle['top'] = top + 'px'
      this.formStyle['left'] = left + 'px'
      this.formStyle['height'] = this.height
      if (!this.formVisible) {
        this.formStyle['display'] = 'none'
      } else {
        delete this.formStyle['display']
      }
    },
    handleMouseDown(event) {
      const className = event?.target?.className
      if (!className || className.indexOf('my-context-menu') === -1) {
        this.formVisible = false
      }
    },
    handleSure(item) {
      if (!item.disabled && !this.disabled) {
        this.$emit('backContextMenu', { menu: item })
        this.formVisible = false
      }
    }
  },
  watch: {
    formVisible: {
      handler(newValue) {
        if (!newValue) {
          this.showOptions = []
          this.formStyle['display'] = 'none'
          window.removeEventListener('mousedown', this.handleMouseDown)
        } else {
          window.addEventListener('mousedown', this.handleMouseDown)
        }
      },
      deep: true
    }
  },
  computed: {
    height() {
      if (this.showOptions.length === 0) {
        return '2px'
      } else if (this.showOptions.length * 32 > this.$store.state.clientHeight / 2) {
        return this.$store.state.clientHeight / 2 + 'px'
      } else {
        return this.showOptions.length * 32 + 'px'
      }
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .vxe-modal--body {
  margin: 0;
  padding: 0;
}
.my-context-menu-box {
  z-index: 9999;
  position: fixed;
  background-color: #fff;
  overflow-y: auto;
  overflow-x: auto;
  color: #606266;
  border: 1px solid #dcdfe6;
  font-size: 12px;
  box-shadow: 2px 2px 3px #a4a4a4;
}
.my-context-menu-block {
  ul {
    text-align: center;
    margin: 0 0 0 0;
    padding: 0 0 0 0;
    li {
      padding: 0 10px 0 10px;
      align-items: center;
      height: 30px;
      line-height: 30px;
      min-width: 100px;
      max-width: 500px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-break: break-all;
      list-style-type: none;
      width: auto;
      border: 1px solid #fff;
    }
    li:hover {
      cursor: pointer;
      background: #cfcdcf;
      border: 1px solid #fff;
    }
  }
}
.my-context-menu-item-disabled {
  background: #fff !important;
  color: #cfcdcf !important;
}
.my-context-menu-item-disabled:hover {
  cursor: not-allowed !important;
  border: 1px solid #cfcdcf !important;
}
</style>
